import { createCrudApi } from '@core/api/createCrudApi';
import type { BaseEntity } from '@core/interfaces';
import { VestmentCategory } from '../src/enum/vestmentCategory';
import type { VestmentType } from '../src/enum/vestmentType';

export interface Size extends BaseEntity {
  name: string;
  vestmentCategory: VestmentCategory;
  vestmentType?: VestmentType | null;
  length?: number | null;
  shoulder?: number | null;
  sleeve?: number | null;
  neck?: number | null;
  chest?: number | null;
  waist?: number | null;
  figure?: number | null;
  head?: number | null;
  sortOrder?: number;
}

export interface CreateSizeData {
  name: string;
  vestmentCategory: VestmentCategory;
  vestmentType?: VestmentType | null;
  length?: number;
  shoulder?: number;
  sleeve?: number;
  neck?: number;
  chest?: number;
  waist?: number;
  figure?: number;
  head?: number;
}

export type UpdateSizeData = Partial<CreateSizeData>;

const sizeApi = createCrudApi<Size, CreateSizeData, UpdateSizeData>('size');

export const getAllSizes = sizeApi.getAll;
export const getSizeById = sizeApi.getById;
export const createSize = sizeApi.create;
export const updateSize = sizeApi.update;
export const deleteSize = sizeApi.delete;
export const reorderSizes = sizeApi.reorder;
